import { request } from '@/utils/request';

// 获得状态
export const isLogin = options => request('post', '/app-api/wx/user/isLogin', {
  ...options
});

// 获得signature
export const getSignature = options => request('post', '/app-api/member/wx-mp/create-jsapi-signature', {
  ...options
});

// 获取微信授权重定向链接
export const redirectUrl = options => request('post', '/app-api/wx/oauth/redirecturl', {
  ...options
});

// 获取token
export const code2userinfo = options => request('post', '/app-api/wx/oauth/code2userinfo', {
  ...options
});

// 获取授权信息
export const getUserInfo = options => request('get', '/app-api/member/user/get', {
  ...options
});

// 更新个人信息
export const updateRealInfo = options => request('post', '/app-api/member/user/update-realInfo', {
  ...options
});

// 获取个人信息
export const getRealInfo = options => request('get', '/app-api/member/user/get-realInfo', {
  ...options
});

// 获取个人信息
export const getInfo = options => request('post', '/app-api/wx/user/info', {
  ...options
});

// 获得商品分类列表
export const getCategoryList = options => request('get', '/app-api/product/category/list', {
  ...options
});

// 获取商品 - 通过商品id
export const getProductSpu = options => request('get', '/app-api/product/spu', {
  ...options
});

// 获得商品spu分页
export const getProductSpuPage = options => request('get', '/app-api/product/spu/page', {
  ...options
});

// 支付订单
// 提交支付订单
export const submitOrder = options => request('post', '/app-api/pay/order/submit', {
  ...options
});

// 渠道统一的支付成功返回地址
export const returnChannelId = options => request('get', '/app-api/pay/order/return/{channelId}', {
  ...options
});

// 渠道统一的支付成功,或退款成功 通知url
export const notify = options => request('post', '/app-api/pay/order/notify/{channelId}', {
  ...options
});

// 通知微信公众号支付的结果
export const wxPub = options => request('post', '/app-api/pay/order/notify/wx-pub/{channelId}', {
  ...options
});

// 获得banner列表
export const getBannerList = options => request('get', '/app-api/market/banner/list', {
  ...options
});

// 交易订单
// 创建订单
export const createOrder = options => request('post', '/app-api/trade/order/create', {
  ...options
});

// 删除订单
export const deleteOrder = options => request('post', '/app-api/trade/member-user-benefits/delete', {
  ...options
});

// 单独加项
export const getaddbenefitssku = options => request('post', '/app-api/product/sku/getaddbenefitssku', {
  ...options
});

// 单独加项
export const addBenefits = options => request('post', '/app-api/trade/order/addBenefits', {
  ...options
});

// 升级权益
export const upBenefits = options => request('post', '/app-api/trade/order/upBenefits', {
  ...options
});

// 获得交易订单
export const getOrder = options => request('get', '/app-api/trade/order/get', {
  ...options
});

// 获得订单交易分页
export const getOrderPage = options => request('get', '/app-api/trade/order/page', {
  ...options
});

// 提交退款订单
export const refundOrder = options => request('post', '/app-api/pay/refund/refund', {
  ...options
});

// 获得产品sku与会员权益关系
export const getBenefits = options => request('post', '/app-api/product/sku/benefits', {
  ...options
});

// 获得用户权益列表
export const getBenefitsList = options => request('get', '/app-api/trade/member-user-benefits/list', {
  ...options
});

// 激活用户权益
export const activateUserBenefits = options => request('post', '/app-api/trade/member-user-benefits/active', {
  ...options
});

// 激活用户权益
export const beforeActivateRefund = options => request('post', '/app-api/trade/member-user-benefits/refund', {
  ...options
});

// 获得文章列表
export const getArticleList = options => request('get', '/app-api/content/article-config/list', {
  ...options
});

// 获得文章列表分页
export const getArticlePage = options => request('get', '/app-api/content/article-config/page', {
  ...options
});

// 获得问卷配置
export const getQuestion = options => request('get', '/app-api/questionnaire/paper/get', {
  ...options
});

// 创建问卷答案
export const createQuestionAnswer = options => request('post', '/app-api/questionnaire/answer/create', {
  ...options
});

// 获得商品升级配置列表
export const getUpgradeInfos = options => request('get', '/app-api/product/upgrade-config/getUpgradeInfos', {
  ...options
});

// 上传文件
export const uploadFile = options => request('post', '/app-api/member/file/upload', {
  ...options
});

// 通过商品skuId获取
export const getBySkuCode = options => request('post', 'app-api/product/sku/get-option', {
  ...options
});

// 获得商品 SKU 选项的列表
export const getOptionList = options => request('post', '/app-api/product/sku/get-option-list', {
  ...options
});

// 通过商品Code获取
export const getBySpuCode = options => request('get', '/app-api/product/spu/getBySpuCode', {
  ...options
});

// 获取商品Code
export const getBySpuCodeList = options => request('get', '/app-api/product/spu/page', {
  ...options
});